/**
 * Formata uma data/hora para o fuso e a convenção locais do PC.
 *
 * O SERP devolve datas em ISO/GMT (ex.: "2026-06-23T15:44:00Z"). Aqui convertemos
 * para o horário local do usuário (pt-BR, dia/mês/ano hh:mm). Se o valor não for uma
 * data parseável (ex.: "há 2 horas" ou vazio), devolvemos o texto original.
 */
export function formatNewsDate(value: string | null | undefined): string {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value; // não-ISO (relativo etc.) — mantém
  return d.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
